/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

var core = require('../core');

/**
 * Layer source to work with Sputnik.ru tile server.
 */
var SPUTNIK_URL_TEMPLATE = 'http://tiles.maps.sputnik.ru/{z}/{x}/{y}.png?apikey={apikey}';
var SPUTNIK_ATTRIBUTIONS = '<a href="http://maps.sputnik.ru/">Спутник</a> ' + '&copy; <a href="http://rt.ru/">Ростелеком</a> ' + '&copy; <a href="https://openstreetmap.org/">Openstreetmap</a>, ' + new Date().getFullYear();

var props = {
  url: {
    type: String,
    default: SPUTNIK_URL_TEMPLATE
  },
  apiKey: {
    type: String
  },
  attributions: {
    type: String,
    default: SPUTNIK_ATTRIBUTIONS
  }
};

var computed = {
  /**
   * @type {string[]}
   */
  urlTokens: function urlTokens() {
    return ['apiKey'];
  }
};

var Source = {
  name: 'vl-source-sputnik',
  mixins: [core.xyzSource],
  props: props,
  computed: computed
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/sputnik-source/index.js
// module id = 1196
// module chunks = 1